export const createDispatcher = (option?: { type: 'single' }) => {
  return (array: string[], value: string) => {
    const set = new Set(option?.type === 'single' ? [] : array)
    set.has(value) ? set.delete(value) : set.add(value)
    return Array.from(set)
  }
}
